/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FolderMenuOption_portfolio = {
    readonly serviceId: string | null;
    readonly firstItemImage: string | null;
    readonly isPublic: boolean | null;
    readonly items: {
        readonly totalResults: number | null;
    } | null;
    readonly name: string | null;
    readonly " $refType": "FolderMenuOption_portfolio";
};
export type FolderMenuOption_portfolio$data = FolderMenuOption_portfolio;
export type FolderMenuOption_portfolio$key = {
    readonly " $data"?: FolderMenuOption_portfolio$data;
    readonly " $fragmentRefs": FragmentRefs<"FolderMenuOption_portfolio">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FolderMenuOption_portfolio",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "large"
        }
      ],
      "kind": "ScalarField",
      "name": "firstItemImage",
      "storageKey": "firstItemImage(size:\"large\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPublic",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioItemsConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "PortfolioV2",
  "abstractKey": null
};
(node as any).hash = 'cc4175eb7831c05aa07c2b47eb1f0bf3';
export default node;
